/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_DoneInputs */

const es_chat_share_modal_done = /** @type {(inputs: Chat_Share_Modal_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const en_chat_share_modal_done = /** @type {(inputs: Chat_Share_Modal_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Chat_Share_Modal_DoneInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_done = /** @type {((inputs?: Chat_Share_Modal_DoneInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_DoneInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_done(inputs)
	return en_chat_share_modal_done(inputs)
});
export { chat_share_modal_done as "chat.share_modal.done" }